import * as React from 'react';
import { AnimationLayoutGroup } from '../common/Animation';
import { SubAgentMasterLimitExceedContainer } from './components/SubAgentMasterLimitExceed';
import { PublishTermsLoaderContainer } from './components/PublishTermsLoader';
import { PublishTermsErrorContainer } from './components/PublishTermsError';
import { AreaPartsContainer } from './components/AreaParts';
import { MultiPostingContainer } from './components/MultiPosting';
import { PublicationWrapper } from './components/PublicationWrapper';
import { PromotionWrapper } from './components/PromotionWrapper';
import { PublicationSectionContainer } from './components/PublicationSection';
import { PromotionSectionContainer } from './components/PromotionSection';
import { MessageWrapper } from './components/MessageWrapper';

interface IPublishTermsWrapperProps {
  isLoading: boolean;
  isError: boolean;
  isSubagentLimitExceed: boolean;
  promotionSubheader: string | null;
}

export const PublishTerms = ({
  isLoading,
  isError,
  isSubagentLimitExceed,
  promotionSubheader,
}: IPublishTermsWrapperProps) => {
  switch (true) {
    case isLoading:
      return (
        <PublicationWrapper>
          <PublishTermsLoaderContainer />
        </PublicationWrapper>
      );

    case isSubagentLimitExceed:
      return (
        <PublicationWrapper>
          <SubAgentMasterLimitExceedContainer />
        </PublicationWrapper>
      );

    case isError:
      return (
        <PublicationWrapper>
          <PublishTermsErrorContainer />
        </PublicationWrapper>
      );

    default:
      return (
        <AnimationLayoutGroup>
          <PublicationWrapper>
            <PublicationSectionContainer />
          </PublicationWrapper>

          <PromotionWrapper subheader={promotionSubheader}>
            <PromotionSectionContainer />
          </PromotionWrapper>

          <MessageWrapper>
            <AreaPartsContainer />
            <MultiPostingContainer />
          </MessageWrapper>
        </AnimationLayoutGroup>
      );
  }
};
